import React from 'react';
import { ClockIcon, HeartIcon, XCircleIcon } from 'lucide-react';
const PainPoints = () => {
  return <section className="w-full py-16 px-6 md:px-12 lg:px-24" data-id="element-87">
      <div className="max-w-4xl mx-auto" data-id="element-88">
        <h2 className="text-3xl font-bold text-center text-[#C17A47] mb-8" data-id="element-89">
          ¿Te suena familiar?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-90">
          <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-91">
            <div className="w-12 h-12 flex items-center justify-center bg-[#F9E4D4] rounded-full mb-4" data-id="element-92">
              <ClockIcon className="w-6 h-6 text-[#C17A47]" data-id="element-93" />
            </div>
            <p className="text-[#6B5A45]" data-id="element-94">
              Son las 7 PM y no sabes qué cocinar.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-95">
            <div className="w-12 h-12 flex items-center justify-center bg-[#F9E4D4] rounded-full mb-4" data-id="element-96">
              <XCircleIcon className="w-6 h-6 text-[#C17A47]" data-id="element-97" />
            </div>
            <p className="text-[#6B5A45]" data-id="element-98">
              Tus hijos ya tienen hambre, pero lo único rápido es comida
              chatarra.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-99">
            <div className="w-12 h-12 flex items-center justify-center bg-[#F9E4D4] rounded-full mb-4" data-id="element-100">
              <HeartIcon className="w-6 h-6 text-[#C17A47]" data-id="element-101" />
            </div>
            <p className="text-[#6B5A45]" data-id="element-102">
              Abres la nevera y suspiras… otra vez lo mismo.
            </p>
          </div>
        </div>
        <div className="bg-[#F9F4EE] p-8 rounded-lg" data-id="element-103">
          <h3 className="text-2xl font-semibold text-[#C17A47] mb-4" data-id="element-104">
            Pero ahora imagina soltar ese estrés… Y sentir que la cena fluye.
          </h3>
          <p className="text-lg text-[#6B5A45] mb-6" data-id="element-105">
            Imagina esto: Llegas a casa. Abres tu ebook. Eliges una receta
            rápida.
          </p>
          <p className="text-lg text-[#6B5A45] font-medium" data-id="element-106">
            En 15 minutos… La mesa está servida. Tus hijos felices. Tú relajada.
            Y piensas: "¿Por qué no lo hice antes?"
          </p>
        </div>
      </div>
    </section>;
};
export default PainPoints;